import { sortNewestFirst } from './newestFirst';

export function isActionableOrderStatus(status: string | null | undefined): boolean {
  const key = String(status || '').toLowerCase().trim();
  return key !== '' && key !== 'completed' && key !== 'cancelled';
}

export function ensurePinnedOrderPresent<T extends { id: string; status: string }>(
  orders: T[],
  pinned: T | null
): T[] {
  const list = Array.isArray(orders) ? orders : [];
  if (!pinned || !isActionableOrderStatus(pinned.status)) return list;
  if (list.some((order) => order.id === pinned.id)) return list;
  return [pinned, ...list];
}

/** Keep a history-opened ticket in view until it is completed/cancelled. */
export function mergePinnedIntoActiveOrders<T extends { id: string; status: string; created_at: string }>(
  orders: T[],
  pinned: T | null,
  opts?: { focusOnly?: boolean }
): T[] {
  const live = sortNewestFirst(
    (orders || []).filter((order) => isActionableOrderStatus(order.status)),
    (order) => order.created_at
  );
  if (!pinned || !isActionableOrderStatus(pinned.status)) return live;
  const latest = live.find((order) => order.id === pinned.id) || pinned;
  if (opts?.focusOnly) return [latest];
  const rest = live.filter((order) => order.id !== pinned.id);
  return [latest, ...rest];
}
